export function normalizeGuess(text) {
  return String(text || "")
    .trim()
    .toLowerCase()
    .replace(/\s+/g, " ");
}

export function isCorrectGuess(guess, answer) {
  const g = normalizeGuess(guess);
  const w = normalizeGuess(answer);
  return g.length > 0 && g === w;
}

function levenshtein(a, b) {
  const m = a.length;
  const n = b.length;
  const dp = Array.from({ length: m + 1 }, () => new Array(n + 1).fill(0));
  for (let i = 0; i <= m; i += 1) dp[i][0] = i;
  for (let j = 0; j <= n; j += 1) dp[0][j] = j;
  for (let i = 1; i <= m; i += 1) {
    for (let j = 1; j <= n; j += 1) {
      const cost = a[i - 1] === b[j - 1] ? 0 : 1;
      dp[i][j] = Math.min(dp[i - 1][j] + 1, dp[i][j - 1] + 1, dp[i - 1][j - 1] + cost);
    }
  }
  return dp[m][n];
}

/** Near match — not exact, but plausibly close. */
export function isCloseGuess(guess, answer) {
  const g = normalizeGuess(guess);
  const w = normalizeGuess(answer);
  if (!g || !w || g === w) return false;
  if (w.includes(g) || g.includes(w)) return Math.min(g.length, w.length) >= 3;
  const maxLen = Math.max(g.length, w.length);
  const dist = levenshtein(g, w);
  if (maxLen <= 4) return dist <= 1;
  if (maxLen <= 8) return dist <= 2;
  return dist / maxLen <= 0.25;
}

export function guessStatus(guess, answer) {
  if (isCorrectGuess(guess, answer)) return "correct";
  if (isCloseGuess(guess, answer)) return "close";
  return "wrong";
}

export function isTabooWordGuess(guess, tabooWords) {
  const g = normalizeGuess(guess);
  if (!g) return false;
  return (Array.isArray(tabooWords) ? tabooWords : []).some((t) => {
    const w = normalizeGuess(t);
    return w && w === g;
  });
}

export function guessStatusTaboo(guess, answer, tabooWords) {
  if (isCorrectGuess(guess, answer)) return "correct";
  if (isTabooWordGuess(guess, tabooWords)) return "taboo";
  if (isCloseGuess(guess, answer)) return "close";
  return "wrong";
}
